import React, { useEffect, useState } from "react";
import { Spin } from "antd";

//components
import SaveToExistingForm from "./SaveToExistingForm";
import CreateNewCampaignForm from "./CreateNewCampaignForm";
import notification from "@/components/notifications";
import { getSuccessMessage } from "../SaveToShortlistForm/SaveToShortListForm";

//helpers
import campaigns from "@/api/query/campaigns";
import useUserProfile from "../../hooks/useUserProfile";
import { useCompletedStepModalContext } from "@/contexts/CompletedStepModalContext";

// interfaces
import { ISpaceFull } from "@/types/Space";
import { ICampaign } from "@/types/api/Campaign";

//styles
import styles from "@/assets/styles/containers/shortlist-form.module.scss";


interface ShortlistFormProps extends React.HTMLAttributes<HTMLDivElement> {
  space: ISpaceFull;
  onToggleForm?: () => void;
}

const ShortlistForm = ({ space, onToggleForm, ...rest }: ShortlistFormProps) => {
  const [isCreateNewCampaign, setIsCreateNewCampaign] = useState(false);
  const { isAuthorized, data: userData } = useUserProfile();

  const { data, isLoading, refetch, remove } = campaigns.useGetAllCampaigns({
    params: { status: 0, limit: 10 },
    config: { enabled: isAuthorized }
  });

  const { setState: completedStepModalSetState } = useCompletedStepModalContext();

  const toggleForm = () => {
    setIsCreateNewCampaign(!isCreateNewCampaign);

    onToggleForm && onToggleForm();
  };

  useEffect(() => remove, []);

  //methods
  const handleToggleCampaign = (e: boolean) => {
    refetch();

    if (!e && userData?.progressBar as number < 4) {
      completedStepModalSetState({
        open: true,
        type: "add-space",
        spaceSlug: space.slug,
        locationSlug: space.location.slug,
        progressBar: 4,
      });
    }
  }

  const onSuccess = async (campaign: ICampaign) => {
    await refetch();

    if (userData?.progressBar as number < 4) {
      completedStepModalSetState({
        open: true,
        type: "create-campaign-add-space",
        spaceSlug: space.slug,
        locationSlug: space.location.slug,
        progressBar: 4
      });
    }

    notification({
      placement: "topRight",
      duration: 30,
      actionText: "View campaign",
      actionProps: { href: `/campaign/${campaign.id}/planner` },
      message: getSuccessMessage(space.name, campaign),
      type: "success",
    });
  };

  if (isLoading) {
    return (
      <div className={styles["locl-shortlist-form__loader"]}>
        <Spin className={styles["locl-shortlist-form__loader__spin"]} />
      </div>
    )
  }

  return (
    <div className={styles["locl-shortlist-form"]} { ...rest } >
      {!isCreateNewCampaign
        ? (
          <SaveToExistingForm
            campaigns={data?.results?.filter(campaign => campaign.state !== "Archived")}
            toggleForm={toggleForm}
            space={space}
            onCampaignToggle={handleToggleCampaign}
          />
        )
        : (
          <CreateNewCampaignForm
            toggleForm={toggleForm}
            space={space}
            onSuccess={onSuccess}
          />
        )}
    </div>
  );
};

export default React.memo(ShortlistForm);
